import React, { Component } from 'react'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import './index.less'

/**
* @description App内宝箱规则页面
*/

export default class extends Component {
  async componentDidMount() {
    setDocumentTitle("Rules")
  }
  state = {
    lang: langM.ar,
    language:'en',
  }
  async componentWillMount() {
    document.body.style.backgroundColor = "transparent"
    let { language } = this.props.location.query
    language = await getlang(language)
    const pos = language == 'ar' ? '2.1rem' : '0'
    this.setState({
      lang: setlang(language, langM),
      language: language,
      position: pos,
      position2: pos
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  RunOnStart = () => {
  }

  render() {
    return (
      <div className={`case-rule-main ${this.state.language == 'ar' ? "ar" : ""}`}>
        <div className={`rule-box`} dangerouslySetInnerHTML={{ __html: this.state.lang.ruleTxt }}></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/caserule/index.js